import React from 'react';

import ReactDOM from 'react-dom/client';

import './index.css';

import App from './App';

import {

  AuthProvider

} from './context/AuthContext';

console.log(
  "Page loaded at",
  new Date().toLocaleTimeString()
);

// 🚀 CREATE ROOT
const root =
  ReactDOM.createRoot(
    document.getElementById('root')
  );

// 🔐 GLOBAL AUTH PROVIDER
root.render(

  <AuthProvider>

    <App />

  </AuthProvider>
);